














import { Vue, Component, Prop } from 'vue-property-decorator';
import FileIcon from '@/components/icons/FileIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import { LogoFile } from '@/store/modules/organisation';

@Component({
  components: {
    FileIcon,
    DeleteIcon
  }
})

export default class LogoComponent extends Vue {
  @Prop(Object)
  logo!: LogoFile;
  @Prop(Boolean)
  disabled!: boolean;
  @Prop(String)
  logoName!: string;

  maxLogoSize = 10000000;

  get isLogoToLarge() {
    if (this.logo == null) {
      return false;
    }
    return this.logo.file ? this.logo.file.size > this.maxLogoSize : false;
  }

  get shouldShowPlaceholder() {
    if (this.logoName != null && this.logoName !== "") {
      return true;
    }
  }

  get isUploading() {
    if (this.logo !== null) {
      return true;
    }
  }
}
